import { Box, Button, Typography } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import IpfsGenerator from "./IpfsGenerator";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

function NftMintForm() {
  const collectionId = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const nftConfiguarationDetail = location.state;
  const [edit, setEdit] = useState(false);
  const [ipfsDialog, setIpfsDialog] = useState(false);

  const handleIpfsClickOpen = () => {
    setIpfsDialog(true);
  };

  const handleIpfsClose = () => {
    setIpfsDialog(false);
  };

  function editForm() {
    if (nftConfiguarationDetail) {
      setArgumentValue(nftConfiguarationDetail.nftDetails);
      setEdit(true);
    }
  }

  const [functionArguments, setFunctionArguments] = useState([]);
  const [argumentValue, setArgumentValue] = useState([]);

  const onHandleArguments = (index, event) => {
    const { value } = event.target;

    const newArgumentValue = [...argumentValue];
    newArgumentValue[index] = value;
    setArgumentValue(newArgumentValue);
  };

  async function submitForm(e) {
    e.preventDefault();
    try {
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting/collection/nft-detail`,
          {
            formValues: argumentValue,
            collectionId: collectionId.id,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            swal({
              text: response.data.message,
              icon: "success",
            });
            setArgumentValue([]);
            navigate("/nft-minting/collection-detail/" + collectionId.id);
          } else {
            swal({
              text: "Something Went Wrong!",
              icon: "warning",
            });
          }
        });
    } catch (error) {
      swal({
        text: "Something Went Wrong!",
        icon: "error",
      });
    }
  }

  async function submitEditForm(e) {
    e.preventDefault();
    try {
      await axios
        .put(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting/collection/nft-detail`,
          {
            formValues: argumentValue,
            collectionId: collectionId.id,
            nftId: nftConfiguarationDetail.nftId,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            swal({
              text: response.data.message,
              icon: "success",
            });
            setArgumentValue([]);
            navigate("/nft-minting/collection-detail/" + collectionId.id);
          } else {
            swal({
              text: "Something Went Wrong!",
              icon: "warning",
            });
          }
        });
    } catch (error) {
      swal({
        text: "Something Went Wrong!",
        icon: "error",
      });
    }
  }

  async function onload() {
    try {
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting/collection-details?collectionId=${collectionId.id}`,
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setFunctionArguments([...response.data.collectionDetails.argument]);
            functionArguments.forEach(() => {
              const newArgumentValue = [...argumentValue];
              newArgumentValue.push("");
              setArgumentValue(newArgumentValue);
            });
          }
        });
    } catch (error) {
      swal({
        text: "Something Went Wrong",
        icon: "error",
      });
    }
  }

  useEffect(() => {
    onload();
    editForm();
  }, []);
  return (
    <Box m="20px">
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          backgroundColor: "white",
          boxShadow: 4,
        }}
      >
        <IpfsGenerator
          open={ipfsDialog}
          handleClickOpen={handleIpfsClickOpen}
          handleClose={handleIpfsClose}
        />
        <Header title="Configure" subtitle="Fill the required Field" />
        <form onSubmit={edit ? submitEditForm : submitForm}>
          {functionArguments.map((ele, index) => (
            <fieldset
              key={index}
              style={{
                width: "49%",
              }}
              className="login-form "
            >
              <label
                htmlFor="functionName"
                id="functionNameLabel"
                className="login-form-label"
              >
                {ele}
                <div className="input-div-css-1 input-fullwidth input-div-css-2">
                  <div className="input-div-css-3">
                    <input
                      required
                      name="arguments"
                      aria-labelledby="argumentsLabel"
                      type="text"
                      className="input-custom-css input-custom-height"
                      id="arguments"
                      aria-invalid="false"
                      value={argumentValue[index]}
                      onChange={(e) => onHandleArguments(index, e)}
                    ></input>
                  </div>
                </div>
              </label>
            </fieldset>
          ))}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Typography
              className="google-drive-typography-text"
              mb={"5px"}
              mt={"5px"}
            >
              Note: If you need IPFS url for your NFT click here:
            </Typography>
            <Button
              // className="custom-color-button"
              sx={{
                fontSize: "12px",
                marginLeft: "10px",
                fontWeight: "600",
                fontFamily: "Poppins !important",
                color: "rgb(0, 104, 74) !important",
                borderColor: "rgb(0, 104, 74) !important",
              }}
              variant="outlined"
              onClick={() => {
                setIpfsDialog(true);
              }}
              endIcon={<OpenInNewIcon />}
            >
              Generate IPFS url
            </Button>
          </div>
          <Button
            className="custom-color-button"
            sx={{
              fontSize: "15px",
              marginTop: "10px",
            }}
            type="submit"
            variant="contained"
          >
            Submit
          </Button>
        </form>
      </Box>
    </Box>
  );
}

export default NftMintForm;
